import { render, staticRenderFns } from "./shipment-payment-add-modal.vue?vue&type=template&id=79b04fcb&scoped=true"
import script from "./shipment-payment-add-modal.vue?vue&type=script&lang=js"
export * from "./shipment-payment-add-modal.vue?vue&type=script&lang=js"
import style0 from "./shipment-payment-add-modal.vue?vue&type=style&index=0&id=79b04fcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b04fcb",
  null
  
)

export default component.exports